import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48c70c44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parking-info" }
const _hoisted_2 = { class: "price-title" }




export default /*#__PURE__*/_defineComponent({
  __name: 'ParkingInfoCard',
  props: {
    name: null,
    price: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.name), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["price-amount", __props.price ? '' : 'invalid'])
    }, _toDisplayString(__props.price ? __props.price : "-"), 3)
  ]))
}
}

})